import React from "react";

//Actions
import * as ACTIONS from "./../../../../actions/actionConstants";

//Components
import Tooltip from "rc-tooltip";
import Slider from "rc-slider";

//Styles
import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";

//Setup
const Handle = Slider.Handle;

const handleAfterChange = (value, props) => {
  const { dispatch, label } = props;
  if (label === "Adjust Temperature") {
    dispatch({
      type: ACTIONS.HIT_LOGS,
      filter: "changeTemp",
      message: label,
      value
    });
  } else if (label === "Adjust Lights") {
    dispatch({
      type: ACTIONS.HIT_LOGS,
      filter: "changeLights",
      message: label,
      value
    });
  }
};

const handle = props => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Tooltip
      prefixCls="rc-slider-tooltip"
      overlay={value}
      visible={dragging}
      placement="top"
      key={index}>
      <Handle value={value} {...restProps} />
    </Tooltip>
  );
};

const wrapperStyle = { width: "100%" };
const ValueSlider = props => {
  const { data, label } = props;
  return (
    <div style={wrapperStyle}>
      <p>{label}</p>
      <Slider
        min={0}
        max={100}
        defaultValue={data.value}
        handle={handle}
        onAfterChange={e => handleAfterChange(e, props)}
      />
    </div>
  );
};

export default ValueSlider;



// WEBPACK FOOTER //
// ./src/pages/user_dashboard/dashboard_tabs/components/ValueSlider.js